import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
 
    //首页
    {
        path: '/',
        redirect:{name:'/index'},
        component: () => import('../views/layout/layout'),
        children:[
            {
                path: '/index',
                name: '/index',
                component: () => import('../views/index/index')
            },
            {
                path: '/about',
                name: '/about',
                component: () => import('../views/about/about')
            },
            {
                path: '/org',
                name: '/org',
                component: () => import('../views/org/org')
            },
            {
                path: '/honey',
                name: '/honey',
                component: () => import('../views/honey/honey')
            },
            {
                path: '/product',
                name: '/product',
                component: () => import('../views/product/product')
            },
            {
                path: '/project',
                name: '/project',
                component: () => import('../views/project/project')
            },
        ]
    },
   
    // {
    //     path: '/login',
    //     name: 'login',
    //     component: Login
    // },
    // {
    //     path: '/code',
    //     name: 'code',
    //     component: Code
    // },
    //  // 数据大屏
    //  {
    //     path: '/data_screen',
    //     name: '/data_screen',
    //     component: () => import('../views/data_screen')
    //  },
   
    {
        path: '*',
        component: () => import('../views/errors/404')
      
    }
]

const router = new VueRouter({
    routes,
    mode: "hash"
})


export default router
